import { memo } from 'react'
import {
  RaButton,
  RaContainer,
  RaHeading,
  RaIcon,
  RaImage,
  RaPaper,
  RaRichText,
} from '@components/core/index.core'
import { ICONS } from '@constants/icons.constants'

import type { AcfTravelSpecialistPromoProps } from '@typings'

import styles from './acf-travel-specialist-promo.module.scss'

import { RaFormDialogButton } from '@components/form-elements/RaFormDialogButton/RaFormDialogButton'

export const AcfTravelSpecialistPromo = memo(
  ({
    image,
    title,
    phone,
    content,
    cta,
    form,
  }: AcfTravelSpecialistPromoProps) => {
    return (
      <RaContainer>
        <div className={styles['acf-travel-specialist-promo__container']}>
          <RaPaper
            padding={6}
            paddingMobile={4}
            hoverAnimations={['shadow']}>
            <div className={styles['acf-travel-specialist-promo']}>
              <div className={styles['acf-travel-specialist-promo__content']}>
                <RaHeading component="h3">{title.title}</RaHeading>
                <RaRichText content={content} />
                <div className={styles['acf-travel-specialist-promo__buttons']}>
                  <RaFormDialogButton
                    form={form}
                    label={cta}
                    modalTitle={title.title}
                    fullscreen={false}
                  />
                  <RaButton
                    variant="secondary-dark"
                    link={{
                      url: `tel:${phone.replace(' ', '')}`,
                      title: phone,
                    }}
                    startIcon={
                      <RaIcon
                        icon={ICONS.MOBILE_DRAWING}
                        color="dark"
                      />
                    }
                  />
                </div>
              </div>
              <div className={styles['acf-travel-specialist-promo__image']}>
                <RaImage
                  image={image}
                  rotate="right"
                  elevation="light"
                />
              </div>
            </div>
          </RaPaper>
        </div>
      </RaContainer>
    )
  }
)
